'use strict';

require('../../styles/fallbacks/vars.pcss');